/**
 * Personalização do Chat de IA (backend: api/routes/ia_personalizacao.py).
 *
 * Duas entidades irmãs e distintas: a PREFERÊNCIA é instrução durável, injetada
 * sozinha em todo turno; o PROMPT SALVO é texto reutilizável que o usuário
 * dispara no composer. Ver docs/PLANO_PERSONALIZACAO_IA.md.
 */
import { api } from './client';

export interface IaPreferencia {
  id: string;
  texto: string;
  /** MANUAL = cadastrada na tela; IA_AUTO = registrada pela IA durante a conversa. */
  origem: 'MANUAL' | 'IA_AUTO' | string;
  ativo: boolean;
  created_at: string;
  updated_at: string;
}

export interface IaPrompt {
  id: string;
  titulo: string;
  texto: string;
  usos: number;
  ultimo_uso_em?: string | null;
  created_at: string;
  updated_at: string;
}

export async function fetchPreferenciasIa(): Promise<{ preferencias: IaPreferencia[]; limite_ativas: number }> {
  const { data } = await api.get('/ia/preferencias');
  return data;
}

export async function criarPreferenciaIa(texto: string): Promise<IaPreferencia> {
  const { data } = await api.post('/ia/preferencias', { texto });
  return data;
}

export async function atualizarPreferenciaIa(
  id: string,
  payload: { texto?: string; ativo?: boolean },
): Promise<IaPreferencia> {
  const { data } = await api.put(`/ia/preferencias/${id}`, payload);
  return data;
}

export async function excluirPreferenciaIa(id: string): Promise<void> {
  await api.delete(`/ia/preferencias/${id}`);
}

export async function fetchPromptsIa(): Promise<{ prompts: IaPrompt[]; limite: number }> {
  const { data } = await api.get('/ia/prompts');
  return data;
}

/** Top-N por uso — os atalhos exibidos na abertura do chat. */
export async function fetchPromptsSugeridos(): Promise<{ prompts: IaPrompt[]; limite: number }> {
  const { data } = await api.get('/ia/prompts/sugestoes');
  return data;
}

export async function criarPromptIa(titulo: string, texto: string): Promise<IaPrompt> {
  const { data } = await api.post('/ia/prompts', { titulo, texto });
  return data;
}

export async function atualizarPromptIa(id: string, titulo: string, texto: string): Promise<IaPrompt> {
  const { data } = await api.put(`/ia/prompts/${id}`, { titulo, texto });
  return data;
}

export async function excluirPromptIa(id: string): Promise<void> {
  await api.delete(`/ia/prompts/${id}`);
}

export async function registrarUsoPromptIa(id: string): Promise<IaPrompt> {
  const { data } = await api.post(`/ia/prompts/${id}/uso`);
  return data;
}
